import { render, staticRenderFns } from "./tabIdentitasDiri.vue?vue&type=template&id=4b2a7160"
import script from "./tabIdentitasDiri.vue?vue&type=script&lang=js"
export * from "./tabIdentitasDiri.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports